import {Component, OnInit} from '@angular/core';
import {Portalteaser} from "../interfaces/portalteaser";

/**
 * declare the global config that is set as global variable
 */
declare let advisorPortalTeaser: Portalteaser[];

/**
 * List of portal teasers for this current portal/advisors compination.
 *
 * @see TeaserComponent
 */
@Component({
    selector: 'app-portal-teaser',
    templateUrl: './portal.teaser.component.html',
    standalone: false
})
export class PortalTeaserComponent implements OnInit {

  /**
   * list of teaser to be shown
   */
  data: Portalteaser[] = [];

  /**
   * check if there are portalteasers available or not
   */
  static hasPortalTeaser(): boolean {
    return typeof advisorPortalTeaser !== "undefined" && advisorPortalTeaser.length > 0;
  }

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    if(PortalTeaserComponent.hasPortalTeaser()) {
      this.data = advisorPortalTeaser.map(row => {
        // make sure we have a layout set
        row.layout = row.layout ?? 'standard';
        return row;
      });
    }
  }

}
